var AC_Deal = {
  version: 1,
  url_base: "",
  whitelist: ["add", "edit", "delete", "get", "list", "note_add", "note_edit", "pipeline_add", "pipeline_edit", "pipeline_delete", "pipeline_list", "stage_add", "stage_edit", "stage_delete", "stage_list", "task_add", "task_edit", "tasktype_add", "tasktype_edit", "tasktype_delete"]
};
module.exports = AC_Deal;